import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ItemsFilter = (brandName) => {
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const filterItems = (items, categories, filter) => {
    return items.filter((product) => {
      if (filter === "all") return true;
      console.log(product);
      const category = categories.find((cat) => cat.id === product.category_id);
      return category && category.class === filter;
    });
  };

  useEffect(() => {
    console.log(brandName);
    console.log(brandName.brandName);
    const fetchData = async () => {
      try {
        const response = await fetch("../../products.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const brand = data.brands.find(
          (brand) => brand.name === brandName.brandName
        );
        const filteredCategories = data.categories.filter((category) =>
          category.brands.includes(brand.id)
        );
        setCategories(filteredCategories);
        const filteredItems = data.products.filter(
          (item) => item.brand_id === brand.id
        );
        const filteredItemsWithCat = filteredItems.map((item) => {
          const foundCat = data.categories.find(
            (cat) => item.category_id === cat.id
          );
          console.log(foundCat);
          if (!foundCat) {
            console.warn(
              `Category not found for item: ${item.name}, category_id: ${item.category_id}`
            );
            return {
              ...item,
              catName: "Unknown",
              catClass: "cat1",
            };
          }
          return {
            ...item,
            catName: foundCat.name,
            catClass: "cat" + foundCat.class,
          };
        });
        console.log(filteredItemsWithCat);
        setItems(filteredItemsWithCat);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchData();
  }, []);

  const filteredItems = filterItems(items, categories, filter);

  return (
    <div id="product-category-selection" className="filters clearfix">
      <ul className="filter-tabs filter-btns clearfix mb-4">
        <li className="filter">
           <Link to="/brands" className="text-decoration-none">
             <i className="fa fa-arrow-left me-2"></i> back to brands
           </Link>
         </li>
        <li className={`filter active`} onClick={() => setFilter("all")}>
          All
        </li>
        {categories.map((category, i) => (
          <li
            key={i}
            className={`${"cat" + category.class} filter`}
            onClick={() => setFilter(category.class)}
          >
            {category.name.charAt(0).toUpperCase() +
              category.name.replace(/ - /g, "/").slice(1)}
          </li>
        ))}
      </ul>

      <div id="products-display" className="filter-list row">
        {filteredItems.map((product, i) => {
          return (
            <div
              key={i}
              className={`product-block ${product?.catClass} col-lg-4 col-md-6 col-sm-12`}
            >
              <Link
                to={`/brands/${brandName.brandName}/${encodeURIComponent(
                  product.name
                )}`}
                className="text-decoration-none text-dark"
              >
                <div className="inner-box h-100 d-flex flex-column justify-content-center">
                  <div className="image p-1">
                    <img
                      src={`/images/products/${product.name
                        .replace(/\//g, "-")
                        .replace(/\*/g, "-")}.jpg`}
                      alt={product.name}
                      onError={(e) => {
                        // Try JPEG format if JPG fails
                        if (e.target.src.endsWith('.jpg')) {
                          e.target.src = e.target.src.replace('.jpg', '.jpeg');
                        } else {
                          e.target.style.display = 'none';
                          if (e.target.parentElement) {
                            e.target.parentElement.innerHTML = `<div class="text-center p-3 bg-light rounded"><h5 class="mb-0">${product.name}</h5></div>`;
                          }
                        }
                      }}
                    />
                  </div>
                  <div className="content">
                    <h6 className="text-secondary">{product.brand}</h6>
                    <h4>{product.name}</h4>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// The filterProducts function can be imported or defined above this component.
export default ItemsFilter;
